<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1IOVDq/tc-custom/9781446379806.jpg?1708749929300" alt="This image is the cover for the book Crochet Iconic Women"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crochet Iconic Women
      </h1>
      <p class="bookDescription body article font2">
        <b>Crochet patterns depicting world-changing women from Marie Curie to Malala, using the Japanese art of amigurumi.</b><br/><br/>Whether it's Greta, RBG, or Billie Holiday, this collection of crochet patterns celebrates fifteen women who have made an impact on the global stage in fields like politics, sports, and science. Learn more about each of the characters featured in this collection and make unique gifts to inspire and delight all generations.<br/><br/>Marie Curie • Cleopatra • Queen Elizabeth II • Malala Yousafzai • Rosa Parks • Billie Holiday • Ruth Bader Ginsburg • Serena Williams • Greta Thunberg • Jane Goodall • Amelia Earhart • Jane Austen • Florence Nightingale • Audrey Hepburn • Emmeline Pankhurst
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carla Mitrani
      </h2>
      
      <p class="authorDescription body article">Carla Mitrani is an experienced crochet designer with a presence on Etsy and Ravelry where she sells her very popular crochet amigurumi patterns under the brand name Amour Fou Crochet. Carla is best known for her beautifully designed and finished amigurumi dolls. She also collaborates with our other best selling author, Lydia Tresselt (Lalylala).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A David and Charles Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4215c33c